module.exports = __webpack_public_path__ + "static/media/tag.1debe24b.svg";